import { createQueryStringToggleHook } from "../../../../../stores/useQueryState";

export const runFlatParamName = "run-flat";

export const useRunFlat = createQueryStringToggleHook(runFlatParamName, []);
